export var WidgetClosingTrigger;
(function (WidgetClosingTrigger) {
    WidgetClosingTrigger["CloseButton"] = "close_button";
    WidgetClosingTrigger["HelpButton"] = "help_button";
    WidgetClosingTrigger["ClickOutsideWidget"] = "click_outside_widget";
    WidgetClosingTrigger["ChatbotConversation"] = "chatbot_conversation";
})(WidgetClosingTrigger || (WidgetClosingTrigger = {}));
//# sourceMappingURL=widgetClosingTrigger.js.map